import { memo } from 'react';

import { CustomListForm, CustomListFormMode } from 'features/CustomListForm';
import { DeleteCustomListDialog } from 'features/DeleteCustomList';
import {
    RemoveCustomListItemsDialog,
    RemoveCustomListItemsMenu,
    RemoveCustomListItemsMode,
} from 'features/RemoveCustomListItems';

interface CustomListDetailDialogsProps {
    propertyId: string;
    listId: string;
    listName: string;
    showRename: boolean;
    showDelete: boolean;
    showRemoveDialog: boolean;
    removeMode: RemoveCustomListItemsMode;
    menuAnchor: HTMLElement | null;
    pendingListItemIds: string[];
    pendingCatalogItemIds: string[];
    onCloseRename: () => void;
    onCloseDelete: () => void;
    onCloseMenu: () => void;
    onSelectRemoveMode: (mode: RemoveCustomListItemsMode) => void;
    onCloseRemoveDialog: () => void;
    onRemoveSuccess: () => void;
}

export const CustomListDetailDialogs = memo(
    ({
        propertyId,
        listId,
        listName,
        showRename,
        showDelete,
        showRemoveDialog,
        removeMode,
        menuAnchor,
        pendingListItemIds,
        pendingCatalogItemIds,
        onCloseRename,
        onCloseDelete,
        onCloseMenu,
        onSelectRemoveMode,
        onCloseRemoveDialog,
        onRemoveSuccess,
    }: CustomListDetailDialogsProps) => (
        <>
            {showRename ? (
                <CustomListForm
                    mode={CustomListFormMode.RENAME}
                    listId={listId}
                    initialName={listName}
                    propertyId={propertyId}
                    onClose={onCloseRename}
                />
            ) : null}

            <DeleteCustomListDialog
                open={showDelete}
                listId={listId}
                listName={listName}
                propertyId={propertyId}
                onClose={onCloseDelete}
            />

            <RemoveCustomListItemsMenu
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={onCloseMenu}
                onSelect={onSelectRemoveMode}
            />

            <RemoveCustomListItemsDialog
                open={showRemoveDialog}
                mode={removeMode}
                listId={listId}
                listName={listName}
                listItemIds={pendingListItemIds}
                catalogItemIds={pendingCatalogItemIds}
                onClose={onCloseRemoveDialog}
                onSuccess={onRemoveSuccess}
            />
        </>
    ),
);

CustomListDetailDialogs.displayName = 'CustomListDetailDialogs';
